export default __webpack_public_path__ + "assets/images/3052ae126c41fbf900e84bb5c8c10691.jpg";